export const formatPriceRange = (high: number, low: number) => {
  const formattedHigh = formatMoney(high);
  const formattedLow = formatMoney(low);

  if (high === low) {
    return formattedLow;
  } else {
    return low < high
      ? `${formattedLow} - ${formattedHigh}`
      : `${formattedHigh} - ${formattedLow}`;
  }
};

export const formatMoney = (
  amount: number | string,
  locale = 'en-US',
  includeDecimal = false,
) => {
  if (amount === 0) {
    return '$0';
  }

  const cents =
    typeof amount === 'number'
      ? amount
      : parseFloat((Number(amount) * 100).toPrecision(12));

  // Normalize between dollars and cents
  // Cents is XXXX dollars is XX.XX
  const isCents = Number.isInteger(cents) && !/\.00$/.test(cents.toString());

  let output = new Intl.NumberFormat(locale, {
    currency: 'USD',
    style: 'currency',
  }).format(cents / (isCents ? 100 : 1));

  if (!includeDecimal) {
    output = output.replace(/[.,]00$/, '');
  }

  return output;
};
